import React from 'react';
import Header from '../../TutorialHeader';

export default () => (
  <div className="Tutorial-page">
    <div className="Tutorial-text">
      <Header hash="intro">Анализ и создание цветовых схем</Header>
      <p>
        Меня зовут Дима и я программист. Я учился программировать с младшей
        школы, все пять лет ВУЗа смотрел в экран по 12 часов в день, практически
        каждый день. Уже десять лет я работаю программистом.
      </p>
      <p>
        Я радуюсь тому, что у меня всё ещё хорошее зрение и стараюсь о нём
        заботиться. Лучшее, что для этого может сделать программист —
        использовать хорошую цветовую схему. Можно взять готовую, а можно и
        создать свою.
      </p>
      <p>Устраивайтесь поудобнее, я расскажу вам о цветовых схемах.</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/presentational/TutorialPages/01-Title/index.js